import React from 'react';

import ObservationCard from './observation-card';

type Props = {
  observations: Array
}

type State = {
  activeDefinitionID: number,
  active: boolean
}
export default class ObservationCards extends React.Component {
  state: State = {
    activeDefinitionID: 0,
    active: false
  }

  toggleDefinition = (id) => {
    this.setState((prevState) => {
      return {
        active: this.state.activeDefinitionID !== id ? true : !prevState.active,
        activeDefinitionID: id
      };
    });
  }

  props: Props;

  render() {
    return (
      <div>
        {this.props.observations.map((observation, index) => (
          <ObservationCard
            id={index}
            key={index}
            onClick={() => this.toggleDefinition(index)}
            definitionActive={this.state.active}
            activeID={this.state.activeDefinitionID}
            obs={observation}
          />))
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/observation-cards.js